import React from 'react'
import { Button, Tooltip } from '@mui/material'
import ClearAllIcon from '@mui/icons-material/ClearAll'

export interface ClearButtonProps {
  onClick: () => void
  /** Texto do botão e tooltip (ex.: "Limpar", "Limpar filtros"). */
  title?: string
  disabled?: boolean
}

/**
 * Botão de limpar (filtros): mesmo padrão dos outros (ícone + texto).
 * Uso: blocos de filtro nas telas de listagem.
 */
const ClearButton: React.FC<ClearButtonProps> = ({
  onClick,
  title = 'Limpar',
  disabled = false,
}) => (
  <Tooltip title={title}>
    <Button
      variant="contained"
      size="medium"
      startIcon={<ClearAllIcon />}
      onClick={onClick}
      disabled={disabled}
      aria-label={title}
    >
      {title}
    </Button>
  </Tooltip>
)

export default ClearButton
